var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5079 9.20635H13.8095V5.75397H17.2619V3.45238H13.8095V0H11.5079V3.45238H8.05556V5.75397H11.5079V9.20635ZM6.90476 19.5635C5.63889 19.5635 4.61468 20.5992 4.61468 21.8651C4.61468 23.131 5.63889 24.1667 6.90476 24.1667C8.17064 24.1667 9.20635 23.131 9.20635 21.8651C9.20635 20.5992 8.17064 19.5635 6.90476 19.5635ZM18.4127 19.5635C17.1468 19.5635 16.1226 20.5992 16.1226 21.8651C16.1226 23.131 17.1468 24.1667 18.4127 24.1667C19.6786 24.1667 20.7143 23.131 20.7143 21.8651C20.7143 20.5992 19.6786 19.5635 18.4127 19.5635ZM7.1004 15.8234L7.13492 15.6853L8.17064 13.8095H16.744C17.6071 13.8095 18.3667 13.3377 18.7579 12.6242L23.2 4.55714L21.1976 3.45238H21.1861L19.9202 5.75397L16.744 11.5079H8.66548L8.51587 11.1972L5.9381 5.75397L4.84484 3.45238L3.7631 1.15079H0V3.45238H2.30159L6.44444 12.1869L4.89087 15.0063C4.70675 15.3286 4.60317 15.7083 4.60317 16.1111C4.60317 17.377 5.63889 18.4127 6.90476 18.4127H20.7143V16.1111H7.3881C7.23849 16.1111 7.1004 15.9845 7.1004 15.8234Z",
    fill: "#2E0052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.16a909446de47720c8131bbaa397b0e5.svg";
export { ForwardRef as ReactComponent };